import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { Theme } from '../../config/theme';

import { updateAppState } from '../../actions/applicationState';
import { facebookLogin, login } from '../../actions/user';

import Button from '../Button';
import CheckboxField from '../CheckboxField';
import TextField from '../TextField';

const CLOSE_ICON = require('./close.svg');

const DEFAULT_TILE = 'Log in';

let styles;

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = props.closeHandler.bind(this);
    this.setValue = this.updateField.bind(this);
    this.handleSignUp = this.redirectToSignUp.bind(this);
    this.handleEnter = this.loginFormKeyDown.bind(this);
    this.facebookCallback = this.facebookResponse.bind(this);

    this.state = {
      email: '',
      password: '',
      stay_logged_in: false,
    };
  }

  componentDidUpdate() {
    // fixes cursor float bug - modal full width on mobile
    if (this.props.open === true) {
      document.body.classList.add('scroll-locked');
    } else {
      document.body.classList.remove('scroll-locked');
    }
  }

  loginFormKeyDown(event) {
    if (this.state.email && this.state.password && event.keyCode === 13) {
      this.attemptLogin(this.props.history);
    }
  }

  attemptLogin(history) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
          loading_text: 'Fetching...',
        }),
      )
      .then(() => {
        this.props
          .dispatch(login(this.state.email, this.state.password, this.state.stay_logged_in))
          .then(
            response => {
              this.props.dispatch(
                updateAppState({
                  loading: false,
                  login_modal_open: false,
                }),
              );

              if (response.verified === false) {
                history.push('/join/verify');
              } else if (response.completed_membership === true) {
                const searchParams = new URLSearchParams(history.location.search);
                const backURL = searchParams.get('backURL');
                if (backURL) {
                  history.push('/' + backURL);
                } else {
                  history.push('/find');
                }
              } else {
                history.push('/join/profile');
              }
            },
            err => {
              if (err === 'verify') {
                this.props.dispatch(
                  updateAppState({
                    loading: false,
                    login_modal_open: false,
                  }),
                );
                history.push('/join/verify');
              } else {
                this.props.dispatch(
                  updateAppState({
                    loading: false,
                  }),
                );

                this.setState({
                  error: 'Your email or password is incorrect.',
                });
              }
            },
          );
      });
  }

  redirectToSignUp() {
    this.props.dispatch(
      updateAppState({
        loading: false,
        login_modal_open: false,
      }),
    );
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  facebookResponse(response) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
          loading_text: 'Fetching...',
        }),
      )
      .then(() => {
        this.props.dispatch(facebookLogin(response.accessToken)).then(
          () => {
            this.props.dispatch(
              updateAppState({
                loading: false,
                login_modal_open: false,
              }),
            );

            this.props.history.push('/find');
          },
          err => {
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );

            this.setState({
              error: 'Your email or password is incorrect.',
            });

            console.log(err); // eslint-disable-line no-console
          },
        );
      });
  }

  render() {
    const { facebookAppId: APP_ID } = this.props;

    const LoginButton = withRouter(({ history }) => (
      <Button
        title="Log in"
        theme="black"
        handler={() => {
          this.attemptLogin(history);
        }}
        styles={styles.full_width_button}
      />
    ));

    return (
      <Modal
        isOpen={this.props.open}
        className={css(styles.container)}
        onRequestClose={this.handleClose}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 101,
            display: 'flex',
          },
        }}
        contentLabel={
          this.props.title && this.props.title.length > 0 ? this.props.title : DEFAULT_TILE
        }
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>Log in</h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.handleClose}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal" />
            </div>
          </div>
          <div className={css(styles.body)}>
            <FacebookLogin
              appId={APP_ID}
              containerStyle={{
                width: '100%',
              }}
              autoLoad={false}
              isMobile={false}
              fields="first_name,last_name,email,picture"
              callback={this.facebookCallback}
              cssClass="facebook-login-button"
              textButton={false}
              icon={
                <Button
                  title="Log in with Facebook"
                  theme="facebook"
                  styles={styles.full_width_button}
                />
              }
            />
            <div className={css(styles.seperator_container)}>
              <div className={css(styles.seperator_text)}>Or</div>
            </div>
            <TextField
              id="email"
              name="email"
              email
              placeholder="Email"
              fullWidth
              onKeyDown={this.handleEnter}
              error={this.state.error}
              value={this.state.email}
              handler={this.setValue}
            />
            <TextField
              id="password"
              name="password"
              type="password"
              placeholder="Password"
              fullWidth
              onKeyDown={this.handleEnter}
              value={this.state.password}
              handler={this.setValue}
            />
            <div className={css(styles.actions_container)}>
              <Link
                to="/forgot"
                onClick={this.handleSignUp}
                className={css(styles.forgotten_password)}
              >
                Forgotten password?
              </Link>
              <div className={css(styles.login_button_container)}>
                <LoginButton />
              </div>
              <div className={css(styles.stay_logged_in_container)}>
                <CheckboxField
                  id="stay_logged_in"
                  name="stay_logged_in"
                  label="Automatically log me in on this device"
                  value={this.state.stay_logged_in}
                  handler={this.setValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.footer)}>
          <div className={css(styles.sign_up_container)}>
            Not a member?
            <Link className={css(styles.sign_up_link)} to="/join" onClick={this.handleSignUp}>
              Sign up here
            </Link>
          </div>
        </div>
      </Modal>
    );
  }
}

LoginModal.propTypes = {
  open: PropTypes.bool,
  closeHandler: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  facebookAppId: PropTypes.string.isRequired,
  title: PropTypes.string,
};

LoginModal.defaultProps = {
  open: false,
  closeHandler: () => {},
  title: DEFAULT_TILE,
};

const mapStateToProps = state => ({
  facebookAppId:
    (state.appdata && state.appdata.apiKeys && state.appdata.apiKeys.facebook_app_id) || '',
});

styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    minHeight: 640,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    [Theme.mobile_query]: {
      top: 0,
      left: 0,
      borderRadius: 0,
      width: '100%',
      height: '100%',
    },
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px',
    [Theme.mobile_query]: {
      padding: '0px 20px 180px',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px',
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: '900',
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  full_width_button: {
    width: '100%',
    minHeight: 50,
  },
  full_width: {
    width: '100%',
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  seperator_container: {
    display: 'flex',
    height: 25,
    margin: '25px auto',
    alignItems: 'center',
    justifyContent: 'center',
    ':after': {
      content: "' '",
      position: 'absolute',
      width: '100%',
      height: 1,
      backgroundColor: Theme.horizontal_rule_color,
    },
  },
  seperator_text: {
    fontFamily: Theme.font_family_primary,
    backgroundColor: Theme.white,
    zIndex: 10,
    padding: 15,
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    [Theme.mobile_query]: {
      flexWrap: 'wrap',
    },
  },
  footer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    height: 100,
    width: '100%',
    backgroundColor: Theme.light_grey,
    [Theme.mobile_query]: {
      height: 'auto',
      padding: '20px 0',
    },
  },
  sign_up_container: {
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: Theme.font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  forgotten_password: {
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    [Theme.desktop_query]: {
      flex: 1,
    },
    [Theme.mobile_query]: {
      width: '100%',
      order: 2,
      textAlign: 'center',
      marginTop: '1rem',
      marginBottom: '1rem',
    },
  },
  login_button_container: {
    [Theme.desktop_query]: {
      flex: 1,
    },
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  stay_logged_in_container: {
    [Theme.desktop_query]: {
      width: '100%',
      marginTop: '.8rem',
    },
    [Theme.mobile_query]: {
      width: '100%',
      order: 3,
    },
  },
});

export default connect(mapStateToProps)(LoginModal);



// WEBPACK FOOTER //
// ./src/components/LoginModal/index.js